import { useQuery } from "@tanstack/react-query";
import {
  CALENDARS_GET,
  getAllCalendars,
  CalendarResponse,
} from "@/api/client/calendar";

export interface UseCalendarsOptions {
  // Accepts a static gate value (`number | false`, e.g. from `usePollingGate`)
  // or a closure. While the socket is healthy this should be `false` so no
  // interval refetch fires; events drive updates instead.
  refetchInterval?: number | false | (() => number | false);
}

export const useCalendars = ({ refetchInterval }: UseCalendarsOptions = {}) => {
  return useQuery<CalendarResponse[]>({
    queryKey: [CALENDARS_GET],
    queryFn: getAllCalendars,
    refetchInterval,
  });
};